export const SOCIALS = [
  { id: "spotify", label: "Spotify", url: "https://open.spotify.com/artist/0aGPW45UvSWWZi1sX5IwyA" },
  { id: "apple", label: "Apple Music", url: "https://music.apple.com/de/artist/giovanni-costello/201968168" },
  { id: "amazon", label: "Amazon Music", url: "https://music.amazon.it/artists/B008ZG4V0G/giovanni-costello" },
  { id: "youtube", label: "YouTube", url: "https://www.youtube.com/@GiovanniCostelloChannel" },
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/giovannicostello.official/" },
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/giovannicostello.official/" },
];

export const ALBUMS = [
  {
    id: "true-italian-stories",
    title: "True Italian Stories",
    year: "2019",
    type: { de: "Mit der SWR Big Band", en: "With the SWR Big Band" },
    price: 29.9,
    photo: "04",
    cover: "/assets/cover-true-italian-stories.jpg",
    tracks: ["Che Bambola", "Roma", "La Mela", "Meglio stasera", "Se non avessi te", "Il Paradiso", "Il Gioco", "Io dico di no", "Se bastasse una canzone", "Il treno", "Via con me", "Nel blu dipinto di blu (Volare)"],
    desc: {
      de: "Zwölf italienische Klassiker in großen Big Band Arrangements, aufgenommen mit der SWR Big Band.",
      en: "Twelve Italian classics in grand big band arrangements, recorded with the SWR Big Band.",
    },
    links: {
      spotify: "https://open.spotify.com/album/6r7GjuDGysRZfYmJoJkvdp",
      amazon: "https://www.amazon.de/True-Italian-Stories-Giovanni-Costello/dp/B07NR8BQV9",
    },
  },
  {
    id: "splendido",
    title: "Splendido",
    year: "2017",
    type: { de: "Studioalbum · GLM Music", en: "Studio Album · GLM Music" },
    price: 22.0,
    photo: "05",
    cover: "/assets/cover-splendido.jpg",
    tracks: ["Luna e champagne", "Aspettando l'alba", "La mela", "Un amore così", "L'amore folle", "Viva l'amore", "Sonata", "Sanditaliano", "Un uomo splendido", "Una storia normale", "Un angelo", "Caruso", "Io dico di no", "Via con me (live mit der SWR Big Band)"],
    desc: {
      de: "Vierzehn Songs zwischen italienischem Pop und Jazz, mit dem Live Highlight Via con me als Abschluss.",
      en: "Fourteen songs between Italian pop and jazz, closing with the live highlight Via con me.",
    },
    links: { apple: "https://lnk.to/Splendido", spotify: "https://open.spotify.com/album/098hApOapD4n9c1bPYJ6us" },
  },
  {
    id: "il-gioco",
    title: "Il Gioco",
    year: "2013",
    type: { de: "Album · mit der SWR Big Band", en: "Album · with the SWR Big Band" },
    price: 19.9,
    photo: "06",
    cover: "/assets/cover-il-gioco.webp",
    tracks: ["Roma", "Cool", "Stella", "Il Paradiso", "Il Treno", "Two", "Luna E Champagne", "Sei Mia", "L'Amore Folle", "Averti Qui", "La Mia Fantasia", "Il Gioco"],
    desc: {
      de: "Das Erfolgsalbum, das Giovanni Costellos Ruf als italienischen Crooner begründete.",
      en: "The landmark album that established Giovanni Costello as the Italian crooner.",
    },
    links: {},
  },
  {
    id: "in-alto-mare",
    title: "In Alto Mare",
    year: "2022",
    type: { de: "Studioalbum · GLM Music", en: "Studio Album · GLM Music" },
    price: 24.9,
    photo: "02",
    cover: "/assets/cover-in-alto-mare.jpg",
    tracks: ["In alto mare", "Era Bella", "Vivere", "Amami", "Blues", "Guardare Ma Non Toccare", "Gelosia", "Non Avere Paura", "La Donna Cannone"],
    desc: {
      de: "Neun Eigenkompositionen mit mediterranem Flair, edlen Streichern und feinen Jazz Nuancen.",
      en: "Nine original compositions with Mediterranean flair, refined strings and fine jazz nuances.",
    },
    links: {
      apple: "https://music.apple.com/de/album/in-alto-mare/1618033912",
      spotify: "https://open.spotify.com/album/6aknlISkEUaVDIRtvj0J82",
    },
  },
  {
    id: "io-senza-te",
    title: "Io senza Te",
    year: "2005",
    type: { de: "Album", en: "Album" },
    price: 19.9,
    photo: "07",
    cover: "/assets/cover-io-senza-te.jpg",
    tracks: ["Io Senza Te", "Sognando", "The Windmills of Your Mind", "Figli Delle Stelle", "You Are so Beautiful", "Kiss", "Nel Sole, Nel Vento", "Margherita", "L'ultima Spiaggia", "A Song for You"],
    desc: {
      de: "Frühe Aufnahmen voller mediterraner Sehnsucht und italienischem Sentiment.",
      en: "Early recordings full of Mediterranean longing and Italian sentiment.",
    },
    links: { spotify: "https://open.spotify.com/album/2eYwSOGP4fHNdf0UTRmOYb" },
  },
  {
    id: "tenderness",
    title: "Нежность (Tenderness)",
    year: "2020",
    type: { de: "Single", en: "Single" },
    price: 9.9,
    forSale: false,
    photo: "03",
    cover: "/assets/cover-tenderness.jpg",
    tracks: ["Нежность (Tenderness)"],
    desc: {
      de: "Giovanni Costellos einfühlsame Interpretation des russischen Klassikers Нежность.",
      en: "Giovanni Costello's soulful rendition of the Russian classic Нежность (Tenderness).",
    },
    links: {
      spotify: "https://open.spotify.com/album/7GKL9eMKLpBojYCZz7h5lh",
      apple: "https://smarturl.it/costelloTenderness",
      amazon: "https://www.amazon.com/%D0%9D%D0%B5%D0%B6%D0%BD%D0%BE%D1%81%D1%82%D1%8C-Tenderness-Giovanni-Costello/dp/B084GBV6YB",
    },
  },
];

export const VIDEOS = [
  { id: "oT-YB7LqzFw", title: "Roma · Official Video · Giovanni Costello & SWR Big Band", tag: { de: "Offizielles Musikvideo · True Italian Stories", en: "Official Music Video · True Italian Stories" }, featured: true },
  { id: "RmC43W5ft9o", title: "Se non avessi te · Live", tag: { de: "Gala · Düsseldorf", en: "Gala · Düsseldorf" } },
  { id: "03x2JiPMhHY", title: "Feeling Good · TV Mediaset Canale 5", tag: { de: "TV · Italien", en: "TV · Italy" } },
  { id: "VwwjfeMdFXc", title: "Via Con Me · Giovanni Costello & SWR Big Band", tag: { de: "Live · Forum Ludwigsburg", en: "Live · Forum Ludwigsburg" } },
  { id: "UY_o59K-Hdc", title: "Il Gioco · Giovanni Costello & SWR Big Band", tag: { de: "Live · Ehinger Jazztage 2013", en: "Live · Ehingen Jazz Days 2013" } },
  { id: "ucPuTM0E_T0", title: "Caruso · Eisgala 2012", tag: { de: "Live · Ingolstadt", en: "Live · Ingolstadt" } },
  { id: "cljL81RkujQ", title: "Cool · Rudas Studios", tag: { de: "Studio Session", en: "Studio Session" } },
  { id: "rbZJhlSJEPw", title: "Sanditaliano · Official Video", tag: { de: "Offizielles Musikvideo · Splendido", en: "Official Music Video · Splendido" } },
  { id: "9H9dskbfuiI", title: "Il Paradiso · Giovanni Costello & SWR Big Band", tag: { de: "Live · Ehinger Jazztage 2013", en: "Live · Ehingen Jazz Days 2013" } },
  { id: "kuao1LqNwKo", title: "Se bastasse una canzone · SWR TV", tag: { de: "Live TV · SWR", en: "Live TV · SWR" } },
];

export const SHOWS = [
  { id: "munich", date: "18.10.2026", day: "18", month: { de: "OKT", en: "OCT" }, year: "2026", city: "München, DE", venue: "Prinzregententheater", status: "available", url: "#" },
  { id: "zurich", date: "04.11.2026", day: "04", month: { de: "NOV", en: "NOV" }, year: "2026", city: "Zürich, CH", venue: "Tonhalle Zürich", status: "fast", url: "#" },
  { id: "berlin", date: "21.11.2026", day: "21", month: { de: "NOV", en: "NOV" }, year: "2026", city: "Berlin, DE", venue: "Philharmonie Berlin · mit Big Band", status: "available", url: "#" },
  { id: "milano", date: "12.12.2026", day: "12", month: { de: "DEZ", en: "DEC" }, year: "2026", city: "Milano, IT", venue: "Teatro Manzoni", status: "vip", url: "#" },
];

export const GALLERY_SLOTS = [
  { id: "10", src: "/assets/photo-10.jpg", label: { de: "Live am Piano", en: "Live at the piano" }, ratio: "aspect-[4/3]" },
  { id: "19", src: "/assets/photo-19.jpg", label: { de: "Gala Abend", en: "Gala evening" }, ratio: "aspect-[4/5]" },
  { id: "11", src: "/assets/photo-11.webp", label: { de: "Mit der SWR Big Band", en: "With the SWR Big Band" }, ratio: "aspect-[4/3]" },
  { id: "17", src: "/assets/photo-17.jpg", label: { de: "Portrait", en: "Portrait" }, ratio: "aspect-[3/4]" },
  { id: "12", src: "/assets/photo-12.webp", label: { de: "Im Konzertsaal", en: "In the concert hall" }, ratio: "aspect-[4/3]" },
  { id: "15", src: "/assets/photo-15.jpg", label: { de: "Portrait · Editorial", en: "Portrait · editorial" }, ratio: "aspect-[3/4]" },
  { id: "13", src: "/assets/photo-13.jpg", label: { de: "Am Konzertflügel", en: "At the grand piano" }, ratio: "aspect-[4/3]" },
  { id: "16", src: "/assets/photo-16.jpg", label: { de: "TV Bühne", en: "TV stage" }, ratio: "aspect-square" },
  { id: "18", src: "/assets/photo-18.jpg", label: { de: "Portrait · Close up", en: "Portrait · close up" }, ratio: "aspect-[4/3]" },
  { id: "14", src: "/assets/photo-14.webp", label: { de: "Der Anfang · ein besonderer Moment", en: "The beginning · a special moment" }, ratio: "aspect-[3/4]" },
];

export const EUR = (n) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n);
